import {
  API_ERROR,
  GET_PERMSTIONS_LIST,
  GET_PERMSTIONS_LIST_SUCCESSFULL,
  CHECK_PERMSSION,
  CHECK_PERMSSION_FILED,
  SUBMIT_PROFILE,
  GET_PROFILE_DATA,
  GET_PROFILE_DATA_SUCCESSFULL,
  INPUT_CHANGEVALUE,
} from "./actionTypes";

const initialState = {
  ProfileRowData: {},
  persmsitonsList: [],
  checkedPermissions: [],
  error_msg: {},
};

const profile = (state = initialState, action) => {
  switch (action.type) {
    case GET_PERMSTIONS_LIST:
      state = {
        ...state,
        loading: false,
      };
      break;
    case GET_PERMSTIONS_LIST_SUCCESSFULL:
      var permissionlist = action.payload.data.map((item) => {
        var permissionlabels = item.permissions.map((permission) => {
          permission.checked = false;
          return permission;
        });
        item.commonFalse = false;
        item.permissions = permissionlabels;
        return item;
      });
      state = {
        ...state,
        loading: false,
        persmsitonsList: permissionlist,
      };

      break;
    case CHECK_PERMSSION:
      var checkedlist = state.persmsitonsList.map((item) => {
        if (item.id === action.payload.permID) {
          item.commonFalse = !item.commonFalse;
          if (item.commonFalse === false) {
            item.permissions = item.permissions.map((permission) => {
              permission.checked = false;
              state.checkedPermissions = state.checkedPermissions.filter(
                (permission2) => {
                  if (permission2.id !== permission.id) {
                    return true;
                  }
                  return false;
                }
              );
              return permission;
            });
          }
        }
        return item;
      });
      state = {
        ...state,
        loading: false,
        persmsitonsList: checkedlist,
      };
      break;
    case CHECK_PERMSSION_FILED:
      var checkedlist1 = state.persmsitonsList.map((item) => {
        if (item.id === action.payload.permID) {
          var filedChecked = item.permissions.map((permission) => {
            if (permission.id === action.payload.filedID) {
              permission.checked = !permission.checked;
              if (permission.checked === true) {
                state.checkedPermissions = [
                  ...state.checkedPermissions,
                  permission,
                ];
              } else {
                state.checkedPermissions = state.checkedPermissions.filter(
                  (permission) => {
                    if (permission.id !== action.payload.filedID) {
                      return true;
                    }
                    return false;
                  }
                );
              }
            }
            return permission;
          });

          item.permissions = filedChecked;
        }
        return item;
      });

      state = {
        ...state,
        loading: false,
        persmsitonsList: checkedlist1,
      };
      break;
    case SUBMIT_PROFILE:
      state = {
        ...state,
        loading: false,
      };
      break;
    case INPUT_CHANGEVALUE:
      state = {
        ...state,
        loading: false,
        ProfileRowData: {
          ...state.ProfileRowData,
          [action.payload.key]: action.payload.value,
        },
      };
      break;
    case GET_PROFILE_DATA:
      state = {
        ...state,
        loading: false,
      };
      break;
    case GET_PROFILE_DATA_SUCCESSFULL:
      var permissionsIds = action.payload.permissions;
      var permissionlist1 = state.persmsitonsList.map((item) => {
        var permissionlabels = item.permissions.map((permission) => {
          if (permissionsIds.indexOf(permission.id) !== -1) {
            permission.checked = true;
            state.checkedPermissions = [
              ...state.checkedPermissions,
              permission,
            ];
            item.commonFalse = true;
          }
          return permission;
        });

        item.permissions = permissionlabels;
        return item;
      });

      state = {
        ...state,
        loading: false,
        ProfileRowData: action.payload,
        persmsitonsList: permissionlist1,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        loading: false,
        error_msg: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default profile;
